import { requestWrapper } from '@/utils/axiosInstance';

const API_PROJECT = process.env.VUE_APP_PROJECT;

export default {
  async importDoc(doc, query) {
    return await requestWrapper(API_PROJECT, 'POST', '/documents/import', query, doc, true);
  },
};
